import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  buildDockTrack, JORNADA_POR_DEFECTO,
  type DockTrack, type DockVista, type Jornada,
} from '@/utils/dockTimeTracks'

/**
 * El eje del cuadro de muelles, ya con el idioma puesto.
 *
 * Espejo de `useTimeTrack`. La `jornada` la manda el backend en `CuadroMuelles`:
 * si el almacén cambiara su horario, el eje entero se mueve con él, y por eso no
 * es una constante del cliente.
 */
export function useDockTrack(
  vista: DockVista,
  offset: number,
  jornada: Jornada = JORNADA_POR_DEFECTO,
): DockTrack {
  const { t, i18n } = useTranslation()
  return useMemo(
    () => buildDockTrack(vista, offset, { locale: i18n.language, t }, jornada),
    // `t` cambia de identidad al cambiar de idioma, que es justo cuando hay que
    // reconstruir las etiquetas del eje.
    [vista, offset, jornada.inicio, jornada.fin, i18n.language, t],
  )
}
